import { createFileRoute } from "@tanstack/react-router"

import { issueTypeAttachmentsViewStaticData } from "../../../../../../../../views/IssueTypeSettingsAttachmentsView/constants"
import { IssueTypeSettingsAttachmentsView } from "../../../../../../../../views/IssueTypeSettingsAttachmentsView/IssueTypeSettingsAttachmentsView"

export const Route = createFileRoute(
	"/_loggedIn/$organizationId/_map/_layout/settings/issue-types/$issueTypeId/attachments",
)({
	component: IssueTypeSettingsAttachmentsView,
	staticData: issueTypeAttachmentsViewStaticData,
})
